/**
 * Supporting Documents nav label (#1534).
 *
 * Deliberately its own dependency-free module: `Sidebar` needs the formatter
 * but nothing else from `supportingDocumentsCount`, and that module reaches
 * `attachmentService` — i.e. the document picker, blob-util and react-native-fs
 * — to do the counting. Importing it just to append `(3)` to a string would put
 * all of that in the sidebar's module graph (and in every test that renders it).
 */

/**
 * `Supporting Documents (3)`, or the bare label when there is nothing to count.
 *
 * Zero renders as the bare label rather than `(0)` — the same convention the
 * step's own `All Attachments (N)` header uses, and it keeps the nav quiet on a
 * brand-new request where nothing has been uploaded yet. `undefined` means "no
 * open request has reported a count", which reads the same way.
 */
export function formatSupportingDocumentsNavLabel(
  label: string,
  count: number | undefined,
): string {
  if (count == null || !Number.isFinite(count) || count <= 0) {
    return label;
  }
  return `${label} (${count})`;
}
